import type dayjs from "dayjs";

export const isDateRangeValueValid = (startDate?: dayjs.Dayjs | null, endDate?: dayjs.Dayjs | null) => {
  if ((startDate && !endDate) || (!startDate && endDate)) return true;

  if (startDate && endDate) {
    return startDate.isBefore(endDate) || startDate.isSame(endDate);
  }

  return true;
};
